/**
 * @file Contém enums referente a pesquisa
 */
const tipoPesquisa = {
    QUALQUER_RESULTADO: 'Q',
    RESULTADO_EXATO: 'E'
}

const formaPesquisa = {
    ATOS: 'A',
    EDICOES: 'E'    
}
    
const ondePesquisar = {
    TUDO: 'A',
    TITULO: 'T',
    CONTEUDO: 'C'
}
   
const documentos = {
    EDICOES: 'E',
    ATOS: 'A',
    ANEXOS_ATOS: 'AA'       
}
    
export default {tipoPesquisa, formaPesquisa, ondePesquisar, documentos};
